import React, { useEffect, useRef } from 'react';
import { formatMs } from '../utils/time';
import { Link } from 'react-router-dom';

const RankingResultadoList = (props) => {
  const sentinelRef = useRef(null);

  // Scroll infinito: observa un div al final de la lista y pide la
  // siguiente pagina cuando entra en viewport. Se desactiva mientras
  // no haya mas paginas o ya haya una peticion en curso.
  useEffect(() => {
    if (!props.hasMore || props.loadingMore) return undefined;
    const node = sentinelRef.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        props.onLoadMore();
      }
    }, { rootMargin: '200px' });
    observer.observe(node);
    return () => observer.disconnect();
  }, [props.hasMore, props.loadingMore, props.resultados, props.onLoadMore]);

  if (props.ranking && props.resultados) {
    return (
      <div className="w-full">
        <div className="mx-auto max-w-5xl px-0 md:px-40">
          <ul className="space-y-3">
            {props.resultados.map((r) => (
              <li key={`resultado-${r.dorsal}`} className="list-none">
                <Link
                  to={`/competicion/${r.competicion_id}/dorsal/${r.dorsal}`}
                  className="block px-4 py-3 hover:bg-slate-900/70 transition"
                >
                  <div className="flex items-center gap-3">
                    {/* Puesto */}
                    <div className="grid place-items-center h-10 w-10 rounded-lg text-sm font-semibold bg-slate-800 text-slate-200 border border-slate-700">
                      {r.puesto}
                    </div>

                    {/* Nombre + info */}
                    <div className="min-w-0 flex-1">
                      <div className="truncate text-white font-medium font-montserrat">
                        {r.nombre} {r.apellidos}
                      </div>
                      <div className="mt-1 text-sm text-slate-400 font-montserrat">
                        Dorsal <strong className="text-slate-200">{r.dorsal}</strong>
                      </div>
                    </div>

                    {/* Tiempo */}
                    <div className="text-right">
                      <div className="text-white font-mono text-sm">
                        {formatMs(r.valor)}
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          {props.hasMore && (
            <div ref={sentinelRef} className="py-6 text-center text-sm text-slate-500">
              {props.loadingMore ? 'Cargando mas...' : ''}
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default RankingResultadoList;